import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BoardList from '../../components/Board/BoardList';
import BoardDetail from '../../components/Board/BoardDetail';
import Breadcrumb from '../../components/common/Breadcrumb';
import './Notice.scss';
import { useLocation, useNavigate } from 'react-router-dom';

const Notice = () => {
  const [mode, setMode] = useState('list');
  const [selectedPost, setSelectedPost] = useState(null);
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 10;

  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로 정보를 가져옴

  // 경로 일치 여부를 확인하는 함수
  const isActive = (path) => (location.pathname === path ? 'active' : '');

  const fetchNotice = async () => {
    try {
      const res = await axios.get(`/api/user/boards?board_type=notice`);

      // 1. 가상 번호 부여 (전체 개수 기준 역순 정렬 대응)
      // 실제 상세조회 시에는 item.id(또는 idx)를 사용합니다.
      const total = res.data.length;
      const mappedNotice = res.data.map((item, index) => ({
        ...item,
        displayNo: total - index, // 화면 표시용 순번 (1, 2, 3...)
        isNotice: item.is_pinned === 1,
        writer: '관리자',
        date: new Date(item.created_at).toISOString().split('T')[0],
        hasFile: !!item.file_url,
        hit: item.view_count || 0,
      }));

      setData(mappedNotice);
    } catch (err) {
      console.error('데이터 연동 실패:', err);
    }
  };

  useEffect(() => {
    fetchNotice();
  }, []);

  const handleDetail = (post) => {
    setSelectedPost(post);
    setMode('detail');
    window.scrollTo(0, 0);
  };

  // --- 페이징 로직 ---
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = data.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(data.length / postsPerPage);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo(0, 400); // 리스트 상단으로 스크롤 이동
  };

  return (
    <div className="sub-page notice-page">
      <section className="sub-visual notice">
        <div className="container">
          <span className="sub-title">NOTICE</span>
          <h1>공지사항</h1>
          <p>베스트트레이딩의 새로운 소식과 안내사항을 전해드립니다.</p>
        </div>
      </section>
      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/community/notice')} onClick={() => navigate('/community/notice')}>
              공지사항
            </button>
            <button className={isActive('/community/orders')} onClick={() => navigate('/community/orders')}>
              발주관리(준비중)
            </button>
            <button className={isActive('/community/cert')} onClick={() => navigate('/community/cert')}>
              인증서 및 성적서
            </button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        {mode === 'list' ? (
          <>
            <BoardList
              type="notice"
              data={currentPosts} // 10개로 잘린 데이터만 전달
              onDetail={handleDetail}
            />

            {/* 페이징 UI */}
            {data.length > 0 && (
              <div className="pagination">
                <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1} className="page-prev">
                  이전
                </button>
                {[...Array(totalPages)].map((_, i) => (
                  <button key={i + 1} onClick={() => paginate(i + 1)} className={currentPage === i + 1 ? 'active' : ''}>
                    {i + 1}
                  </button>
                ))}
                <button
                  onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}
                  className="page-next"
                >
                  다음
                </button>
              </div>
            )}
          </>
        ) : (
          <BoardDetail
            post={selectedPost}
            allPosts={data}
            onBack={() => setMode('list')}
            onChangePost={(newPost) => setSelectedPost(newPost)}
          />
        )}
      </div>
    </div>
  );
};

export default Notice;
